module.exports = __webpack_public_path__ + "img/9788956372778.3c2ab360.jpg";